import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const USER_DEACTIVATE_GUEST_RESOURCE = "user" as const;
export const USER_DEACTIVATE_GUEST_OPERATION = "deactivate-guest" as const;
export const USER_DEACTIVATE_GUEST_API_PATH =
  `/v1/${USER_DEACTIVATE_GUEST_RESOURCE}/${USER_DEACTIVATE_GUEST_OPERATION}/{uuid}` as const;

export type MutationResponse =
  paths[typeof USER_DEACTIVATE_GUEST_API_PATH]["patch"]["responses"][200]["content"]["application/json"];

export const useUserDeactivateGuestMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<MutationResponse, Error, { uuid: string }>({
    mutationFn: async ({ uuid }) => {
      const response = await alphartisApiAxios.patch<MutationResponse>(
        `/v1/${USER_DEACTIVATE_GUEST_RESOURCE}/${USER_DEACTIVATE_GUEST_OPERATION}/${uuid}`,
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [USER_DEACTIVATE_GUEST_RESOURCE],
      });
    },
  });
};
